import { render, staticRenderFns } from "./tabHrSetting.vue?vue&type=template&id=3982142a&"
import script from "./tabHrSetting.vue?vue&type=script&lang=js&"
export * from "./tabHrSetting.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../Users/qiancheng/Documents/Workspace/cargoware/cargoware-h5-haichuang/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/qiancheng/Documents/Workspace/cargoware/cargoware-h5-haichuang/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('3982142a')) {
      api.createRecord('3982142a', component.options)
    } else {
      api.reload('3982142a', component.options)
    }
    module.hot.accept("./tabHrSetting.vue?vue&type=template&id=3982142a&", function () {
      api.rerender('3982142a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/cargo/v0/PillReport/tabHrSetting.vue"
export default component.exports